export const isDevelopment = process.env.NODE_ENV !== 'production';

const HOST_NAME = window.location.hostname || '';
const DOMAIN = HOST_NAME.slice(HOST_NAME.indexOf('.') + 1);
const PROTOCOL = window.location.protocol;
const ENV_ENUM = {
  TEST: 'raysgo.com',
  UAT: 'raysyun.com',
  PRO: '5rs.me'
};
const ORIGIN_ID_ENUM = {
  TEST: 'gh_ff997f1e1fd2',
  UAT: 'gh_9319d63df3c8', // 书童小ray
  PRO: 'gh_d156ea5a53de'
};
const ORIGIN_ID_ENUM_XIAO_RUI_BAN_XUE = {
  TEST: 'gh_3ce12ad9c87f', // 汉字叔叔
  UAT: 'gh_3ce12ad9c87f', // 汉字叔叔
  PRO: 'gh_1fdd9fcac3b7' // 小睿伴学
};

const ORIGIN_ID_ENUM_BAN_XUE_LE_YUAN = {
  TEST: 'gh_42ac764b7433', // 汉字叔叔
  UAT: 'gh_42ac764b7433', // 汉字叔叔
  PRO: 'gh_c9d1fd646382' // 小睿伴学
};

const BACK_ID_ENUM = {
  TEST: 'gh_d156ea5a53de',
  UAT: 'gh_d156ea5a53de',
  PRO: 'gh_e3b7359fadfc'
};

const ORIGIN_ID_ENUM_BOOKS_GPT_WEAPP = {
  TEST: 'gh_b72ee891f386', // 朗诵100
  UAT: 'gh_b72ee891f386', // 朗诵100
  PRO: 'gh_32c745539a42' // 伴读乐园
};

const obsKeys = {
  DEV: {
    access_key_id: 'TMTKDFCVN0LEU0JGNTJM',
    secret_access_key: '2KSZCysX8YJgE8aQWJuT7kmlnOBcgAJxp5EC7nrO'
  },
  TEST: {
    access_key_id: 'TMTKDFCVN0LEU0JGNTJM',
    secret_access_key: '2KSZCysX8YJgE8aQWJuT7kmlnOBcgAJxp5EC7nrO'
  },
  PRO: {
    access_key_id: 'ROLAKS71MKFKSO4NKDMO',
    secret_access_key: 'ZgL1TVZiOWXWXO2i1tpgZZTI0XvQuniz9gVwEcvG'
  },
  UAT: {
    access_key_id: 'N45I4TP61CRTZSZLBTX7',
    secret_access_key: 'd84O5003ZpZiRcPwyvve5fy1sOoTdt0nAmk1SEDs'
  }
};
let ENV = 'TEST';
Object.keys(ENV_ENUM).forEach(key => {
  if(ENV_ENUM[key] === DOMAIN) {
    ENV = key;
  }
});

const env_config = Object.assign({
  ENV,
  ENV_ENUM
}, ({
  TEST: {
    PRODUCT_DOMAIN: 'https://weixin23.raysgo.com',
    APP_DOMAIN: 'https://app100023.raysgo.com',
    OFFICIAL_ACCOUNT_ID: 23,
    CHANNEL_ID: 1404
  },
  UAT: {
    PRODUCT_DOMAIN: 'https://weixin35515.raysyun.com',
    APP_DOMAIN: 'https://app10035515.raysyun.com',
    OFFICIAL_ACCOUNT_ID: 35515,
    CHANNEL_ID: 35515
  },
  PRO: {
    PRODUCT_DOMAIN: 'https://weixin23.5rs.me', // 作品
    APP_DOMAIN: 'https://app.5rs.me', // 小应用
    OFFICIAL_ACCOUNT_ID: 23,
    CHANNEL_ID: 3
  }
})[ENV]);

const DEFAULT_OFFICIAL_ACCOUNTS_ID = 23;

export { env_config };
export const BASE_API_ROOT = window.location.origin + (isDevelopment ? '/api/' : '/');
export const COOKIE = 'userInfo';
export const cookiePath = {
  path: '/',
  maxAge: 60 * 60 * 24 * 7
};
export const protocol = PROTOCOL;
export const productCode = 'RAYS';
export const domain = DOMAIN;
export const mockApi = 'http://192.168.92.24:6001/mock/';

export const officialAccountsId = isDevelopment ?
  DEFAULT_OFFICIAL_ACCOUNTS_ID : (
    window.location.origin.includes(`weixin${env_config.OFFICIAL_ACCOUNT_ID}`) ? env_config.OFFICIAL_ACCOUNT_ID : DEFAULT_OFFICIAL_ACCOUNTS_ID
  );

export const redirectUrl = window.location.origin;
export const snsapiBase = false; //非静默授权
export const DEFAULT_ALI_OFFICIAL_ACCOUNTS_ID = 888; //默认支付宝id是888
export const DEFAULT_QQ_OFFICIAL_ACCOUNTS_ID = 999; //默认QQ公众号id是999
export const DEFAULT_PHONE_OFFICIAL_ACCOUNTS_ID = 997; //默认手机号授权是997

export const DEFAULT_DOUYIN_OFFICIAL_ACCOUNTS_ID = 88; //抖音授权公众号id88

// 小睿小程序原始ID
export const weappOriginId = ORIGIN_ID_ENUM[ENV];
export const weappBackId = BACK_ID_ENUM[ENV];
// 小睿伴学小程序原始ID
export const weappOriginIdXiaoRuiBanXue = ORIGIN_ID_ENUM_XIAO_RUI_BAN_XUE[ENV];

export const weappOriginIdBanXueLeYuan = ORIGIN_ID_ENUM_BAN_XUE_LE_YUAN[ENV];
// export const weappOfficialAccountsId = 777; // 小程序进入的，weappOfficialAccountsId从query中获取

export const weappOriginIdBooksGptWeapp = ORIGIN_ID_ENUM_BOOKS_GPT_WEAPP[ENV];

export const obsKey = obsKeys[ENV];
export const env = ENV;

export const TRACK_ENTRY_TYPE = 'RAYS_H5';
